module.exports = __webpack_public_path__ + "img/diagram-4.1a9fc49b.svg";